import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal from "../components/Reveal";
import { useSiteContent, resolveImage, fmtPubDate } from "../lib/cms";
import { images } from "../data/content";

export function ArticleCard({ a, i = 0 }) {
  const d = a.data;
  return (
    <Reveal delay={i * 0.1}>
      <Link to={`/news/${a.key}`} className="card-lift group flex h-full flex-col overflow-hidden rounded-2xl border border-sapphire-deep/10 bg-white shadow-sm" data-testid={`article-card-${a.key}`}>
        <div className="aspect-[16/10] overflow-hidden bg-parchment">
          <img src={resolveImage(d.cover_image) || images.templeInterior} alt="" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
        </div>
        <div className="flex flex-1 flex-col p-7">
          <p className="font-sans text-[11px] font-semibold uppercase tracking-[0.25em] text-gold-deep">{fmtPubDate(d.publish_date)}</p>
          <h3 className="mt-3 font-display text-2xl font-semibold leading-snug text-sapphire-deep">{d.title}</h3>
          <p className="mt-3 flex-1 font-sans text-sm leading-relaxed text-charcoal/70">{d.excerpt}</p>
          <span className="mt-5 inline-flex items-center gap-1 font-sans text-sm font-semibold text-sapphire group-hover:text-gold-deep">Read more <ArrowRight size={15} /></span>
        </div>
      </Link>
    </Reveal>
  );
}

export default function News() {
  const { articles, loaded } = useSiteContent();
  return (
    <div data-testid="news-page">
      <section className="relative flex min-h-[42vh] items-end">
        <img src={images.heroHall} alt="" className="absolute inset-0 h-full w-full object-cover" />
        <div className="hero-overlay absolute inset-0" />
        <div className="container-lodge relative z-10 pb-14 pt-28">
          <Reveal>
            <p className="eyebrow">News & Articles</p>
            <h1 className="display-h1 mt-4 max-w-3xl text-parchment">From the Lodge.</h1>
          </Reveal>
        </div>
      </section>
      <section className="bg-paper-texture bg-parchment py-24">
        <div className="container-lodge">
          {loaded && !articles.length ? (
            <p className="font-sans text-charcoal/70" data-testid="news-empty">No articles have been published yet.</p>
          ) : (
            <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3" data-testid="news-list">
              {articles.map((a, i) => <ArticleCard key={a.id} a={a} i={i} />)}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
